import { AttachFile } from '@mui/icons-material';
import React from 'react';
import { WsColors } from 'wisestep-base';

import { FileInput } from './helper';

type FormAttachmentProps = {
  handleAttachments(event: React.ChangeEvent<HTMLInputElement>): void;
};
const FormAttachment = ({ handleAttachments }: FormAttachmentProps) => (
  <FileInput htmlFor="attachments">
    <input
      name="attachments"
      id="attachments"
      type="file"
      style={{ display: 'none' }}
      onChange={(event) => handleAttachments(event)}
    />
    <AttachFile
      sx={{
        '&:hover': {
          color: WsColors.TheBlues500,
          background: WsColors.TheBlues100,
        },
      }}
    />
  </FileInput>
);
export default FormAttachment;
